import {
    ProfessionalDetails,
    RegulatoryProfessionalQualifications
} from "../regulatory-professional-qualifications-interface/regulatory-professional-qualifications.interface";

export class RegulatoryProfessionalQualificationsModel {

    private pias_rep_code!: string;
    private professional_details!: ProfessionalDetails;
    private qualifications!: RegulatoryProfessionalQualifications[];
    private updated_by_role!: string[];

    constructor() { }


    // Pias Rep Code


    getPiasRepCode(): string {
        return this.pias_rep_code;
    }

    setPiasRepCode(pias_rep_code: string) {
        this.pias_rep_code = pias_rep_code;
    }

    // Professional Details


    getProfessionalDetails(): ProfessionalDetails {
        return this.professional_details;
    }

    setProfessionalDetails(professional_details: ProfessionalDetails) {
        this.professional_details = professional_details;
    }

    // Qualifications


    getQualifications(): RegulatoryProfessionalQualifications[] {
        return this.qualifications;
    }

    setQualifications(qualifications: RegulatoryProfessionalQualifications[]) {
        this.qualifications = qualifications;
    }

    // Updated By Role

    getUpdatedByRole(): string[] {
        return this.updated_by_role;
    }

    setUpdatedByRole(updated_by_role: string[]) {
        this.updated_by_role = updated_by_role;
    }


    // Request Payload


    toString() {
        return JSON.stringify({

            pias_rep_code: this.getPiasRepCode(),
            professional_details: this.getProfessionalDetails(),
            qualifications: this.getQualifications()

        });
    }

}
